import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
// moment не бандлит локали автоматически (Vite подключает только дефолтную
// en); без явного импорта moment.locale("ru") в interpolationFormat.ts
// молча остаётся no-op, и {{ value, onlyDate }}/{{ value, month }} рендерят
// английские названия месяцев. Импорт должен идти до первого использования
// moment.locale(lng), поэтому подключаем локаль здесь же, при инициализации.
import "moment/locale/ru";
import { registerInterpolationFormats } from "@/partner/shared/lib";

const baseUrl = import.meta.env.VITE_TRANSLATIONS_API_URL || "";
// Fallback — latest: сборка без явной версии (прод) читает прод-переводы,
// а missing-запросы в latest бекенд сам подменяет на develop. Dev-версию
// задаёт VITE_TRANSLATIONS_VERSION="develop" в .env.development.
const version = import.meta.env.VITE_TRANSLATIONS_VERSION || "latest";
const translationPath = `${baseUrl}/api/v1/translations/cabinet/${version}/{{ns}}/{{lng}}`;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["ru", "en"],
    ns: ["partner"],
    defaultNS: "partner",
    interpolation: { escapeValue: false },
    saveMissing: true,
    returnEmptyString: false,
    backend: {
      loadPath: translationPath,
      addPath: translationPath,
    },
  });

// Форматы дат для интерполяции — {{ createdAt, dateTime }}, {{ n, humanize }}
// и т.д. Набор имён зеркалит site/src/shared/lib/interpolationFormat.
registerInterpolationFormats(i18n);

// eslint-disable-next-line import/no-default-export
export default i18n;
